
import React from 'react';
import { useNavigate } from 'react-router-dom';
import DropdownProfile from './dropdown/profile.jsx';
import logo from '../../assets/Klargo1.png';
import 'bootstrap/dist/css/bootstrap.min.css';
import Items from './navItems/items.jsx';
import { AppSettings } from './../../config/app-settings.js';
import { Container } from "@mui/material";
import { postLoginRedirect } from '../../utils/postLoginRedirect.js';

function Header() {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    const token = localStorage.getItem("authToken");
    if (token) {
      postLoginRedirect(navigate);
    } else {
      navigate("/Home");
    }
  };

  return (
    <AppSettings.Consumer>
      {({
        toggleAppSidebarMobile,
        toggleAppSidebarEndMobile,
        appHeaderMegaMenu,
        appTopMenu,
        appSidebarNone
      }) => (

        <div
          id="header"
          className="app-header"
          style={{
            borderBottom: '3px solid #10b981',
            background: '#fff',
            boxShadow: '0 2px 12px rgba(16,185,129,0.08)'
          }}
        >
          <Container maxWidth="lg">
            <div
              className="d-flex justify-content-between align-items-center "
            >

              <div className="d-flex align-items-center">


                <span
                  className="navbar-brand"
                  onClick={handleLogoClick}
                  style={{
                    color: 'black',
                    fontSize: '18px',
                    fontWeight: 500,
                    textDecoration: 'none',
                    cursor: 'pointer'
                  }}
                >
                  <img
                    src={logo}
                    alt="Klargo"
                    style={{
                      width: "120px",
                      height: "auto",
                      maxWidth: "100%",
                    }}

                  />
                </span>
              </div>


              <div className="d-none d-lg-flex align-items-center gap-3">

                <Items />
              </div>


              <div className="d-lg-none">

                <DropdownProfile />
              </div>
            </div>
          </Container>


        </div>

      )}
    </AppSettings.Consumer>
  );
}

export default Header;
